import useOrganizationMemberCares from '@/hooks/membercare/useOrganizationMemberCares';
import MemberCareDirectoryCard from '@/modules/directory/cards/MemberCareDirectoryCard';
import DirectoryPageTemplate from '@/modules/directory/DirectoryPageTemplate';
import { Text } from '@chakra-ui/react';
import { createFileRoute } from '@tanstack/react-router';

const MemberCareDirectory = () => {
  const { isLoading, data, fetchNextPage, isFetchingNextPage, hasNextPage } = useOrganizationMemberCares(true);

  return (
    <DirectoryPageTemplate
      title="Member Care Team"
      isLoading={isLoading}
      isFetchingNextPage={isFetchingNextPage}
      hasNextPage={hasNextPage}
      onViewMoreClick={() => fetchNextPage()}
    >
      {data?.length === 0 && <Text variant={'urbanistSemiBoldLarge'}>No Member Care team members at the moment</Text>}
      {data?.map((memberCare) => <MemberCareDirectoryCard member={memberCare} showStar key={memberCare?.user_id} />)}
    </DirectoryPageTemplate>
  );
};

export const Route = createFileRoute('/_authenticated/_directory/_member-care/directory/member-care')({
  staticData: { title: 'Member Care' },
  component: MemberCareDirectory,
});
